export default __webpack_public_path__ + "itl-label-info.30b94c5e7ab3d3a95047.svg";